module.exports = __webpack_public_path__ + "1f5fff9a697723c51bfbad2aea6aabb5.woff2";